import React from "react";
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import classNames from 'classnames';

// Material UI
import { withStyles, fade } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from "@material-ui/core/CardContent";
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import NaturePeopleIcon from '@material-ui/icons/NaturePeopleRounded';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';

// Icons
import CloseIcon from '@material-ui/icons/CloseRounded';
import SearchIcon from '@material-ui/icons/SearchRounded';

// Other
import * as actions from '../../../../store/actions/index';
import HeaderMenu from '../UIElements/HeaderMenu';
import InfoMenu from '../UIElements/InfoMenu';
import SpaceMenu from '../UIElements/SpaceMenu';
import { searchStringData } from "../../../DataSearch/Utility";

const styles = theme => ({
    fabBottom: {
        position: 'absolute',
        zIndex: 2,
        right: 772 - 410 + 5 + 10, //687 621
        bottom: 10,
        backgroundColor: 'white'
    },
    fabMenuBottom: {
        position: 'absolute',
        zIndex: 101,
        width: 240,
        right: 772 - 410 + 5 + 10,
        bottom: 78,
        backgroundColor: theme.palette.background.paper,
    },
    fabMenuMobile: {
        position: 'absolute',
        zIndex: 1,
        width: 210,
        right: 68,
        bottom: 68,
        backgroundColor: theme.palette.background.paper,
    },
    fabSelectedBottom: {
        position: 'absolute',
        zIndex: 1,
        height: '56px',
        borderRadius: '28px',
        right: 772 - 410 + 5 + 10,
        bottom: 10,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center'
    },
    fabSelectedBottomMobile: {
        position: 'absolute',
        zIndex: 1,
        height: '48px',
        maxWidth: 300,
        borderRadius: '24px',
        right: 10,
        bottom: 10,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        alignItems: 'center'
    },
    selectedBoxContent: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        paddingRight: '64px',
    },
    moveIn: {
        transform: 'translate3d(-410px, 0, 0)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.enteringScreen,
            easing: theme.transitions.easing.easeOut,
        }),
    },
    moveOut: {
        transform: 'translate3d(0, 0, 0)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp,
        }),
    },
    checklist: {
        backgroundColor: theme.palette.background.paper,
        padding: 0,
    },
    // Search
    search: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    searchIcon: {
        marginRight: 8,
        marginLeft: 8,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        paddingLeft: 38,
        transition: theme.transitions.create('width'),
        width: 140,
    },
});

class MapCustomersMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            checked: [],
            allChecked: true,
            zIdx: 99,
            tempSelectedForest: null,
            searchString: '',
            tempSearchString: '',
            notDisabledForestId: null,
        };
    }

    componentDidMount() {
        // Sort customer list
        if (this.props.customerList) {
            const sortedCustomerList = Object.values(this.props.customerList).sort((a, b) => a.forestName.localeCompare(b.forestName, 'da-DK')).map(el => { return el.id })
            this.populateCheckedObject(sortedCustomerList);
        }
        if (this.props.selectedForest) { this.setState({ allChecked: false }) };
    }

    componentDidUpdate() {
        // Populate checked array 
        if (this.props.customerList) {
            // Check for number of forests according to config and account information
            if (this.props.config.limitNumberOfForests === 'enabled' && this.props.currentAuthUser.forests.length > 0 && !this.props.ownerUpToFiveForestsSub && !this.props.notDisabledForestId) {
                // Check if user has a selected forest data entry (HD and SD)
                if (this.props.currentAuthUser.selectedForests && this.props.currentAuthUser.selectedForests.length > 0 && this.props.customerIdList.includes(this.props.currentAuthUser.selectedForests[0])) {
                    // Check that the selected forest is in the customer list
                    this.props.onSetNotDisabledForestId(this.props.currentAuthUser.selectedForests[0]);
                } else {
                    this.props.onSetNotDisabledForestId(this.props.customerIdList[0]);
                }
            } else if (this.props.notDisabledForestId && this.props.ownerUpToFiveForestsSub) {
                this.props.onSetNotDisabledForestId(null);
            }
            // Set list
            if (this.state.checked.length !== Object.values(this.props.customerList).length && this.state.searchString === '') {
                if (this.state.checked.length > this.props.customerIdList.length) {
                    const checkedIds = this.state.checked.map(el => {
                        return el.id;
                    })
                    const difference = checkedIds.filter(x => !this.props.customerIdList.includes(x));
                    const deletedEl = this.state.checked.filter(el => {
                        return el.id === difference[0];
                    });
                    if (deletedEl[0].state) {
                        this.setState({ allChecked: true })
                    }
                }

                // Sort list
                const sortedCustomerList = Object.values(this.props.customerList).sort((a, b) => a.forestName.localeCompare(b.forestName, 'da-DK')).map(el => { return el.id });
                this.populateCheckedObject(sortedCustomerList);
            } else if (this.state.searchString !== this.state.tempSearchString) {
                // Apply search to customers
                const newArray = searchStringData(this.state.searchString, Object.values(this.props.customerList), ["forestName", "name"]).sort((a, b) => a.forestName.localeCompare(b.forestName, 'da-DK')).map(el => { return el.id });
                this.populateCheckedObject(newArray);
                this.setState({ tempSearchString: this.state.searchString })
            }
        }


        // Check if forest is deselected
        if (this.state.tempSelectedForest !== this.props.selectedForest) {
            if (this.props.selectedForest === null) {
                if (!this.state.allChecked) {
                    const updatedChecked = this.state.checked.map(el => {
                        el.state = false;
                        return el;
                    })
                    this.setState({ checked: updatedChecked, allChecked: true })
                }
            }
            // Set selected forest in component state
            this.setState({ tempSelectedForest: this.props.selectedForest })
            // Reset inventorylist filters
            this.props.onSetFilterState(null);
            this.props.onSetShowFilterInMap(false);

        }

        // Forest marker clicked handler
        if (this.props.forestMarkerClickId !== null) {
            this.handleForestMarkerClicked(this.props.forestMarkerClickId);
            this.props.onSetForestMarkerClickId(null);
        }

        // Onboarding initiated handler
        if (this.props.onboardingActive && this.props.onboardingState === 'welcome') {
            this.onExit();
            if (this.state.open) {
                this.setState({ open: false });
            }
        }

        // Check if menu should be brought to front
        if (this.props.menuBringToFrontId === 'custSelect') {
            if (this.state.zIdx !== 101) {
                this.setState({ zIdx: 101 });
            }
        } else {
            if (this.state.zIdx !== 99) {
                this.setState({ zIdx: 99 });
            }
        }
    }

    populateCheckedObject = (data) => {
        // Apply search filter to data
        const checkedObj = data.map(el => {
            const existingElements = this.state.checked.filter(exEl => {
                return exEl.id === el;
            })
            // Map elements
            if (existingElements.length > 0) {
                return existingElements[0];
            } else {
                let state = el === this.props.selectedForest;
                return (
                    { id: el, state: state }
                );
            }
        });
        this.setState({ checked: [...checkedObj] })
    }

    handleClick() {
        this.setState({ open: (this.state.open ? false : true) })
        this.props.onSetMapMenuBringToFrontId('custSelect');
        // Reset search string if menu is closed
        if (!this.state.open) {
            this.setState({searchString: ''})
        }
        // Send event to Analytics
        ReactGA.event({
            category: 'Customer map layer',
            action: `Customer map layer open: ${!this.state.open}`,
            label: `User: ${this.props.currentAuthUser.name}`
        });
    }

    cardClickHandler() {
        this.props.onSetMapMenuBringToFrontId('custSelect');
    }

    handleSearchStringChange = event => {
        this.setState({ searchString: event.target.value })
    };

    handleForestMarkerClicked = (id) => {
        if (this.props.notDisabledForestId && id !== this.props.notDisabledForestId) {
            // 
            this.props.onEnqueueSnackbar({
                message: this.props.config.limitOfForestsReachedText,
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'info',
                },
            });
            // Send event to Analytics
            ReactGA.event({
                category: 'Customer map layer',
                action: `Forest marker clicked, but forest disabled`,
                label: `User: ${this.props.currentAuthUser.name}`
            });
        } else {
            this.setState({ allChecked: false });

            const updatedChecked = this.state.checked.map(el => {
                if (el.id === id) {
                    el.state = true;
                    this.props.onSetCurrentlySelectedForestId(el.id);
                } else {
                    el.state = false;
                }
                return el;
            })

            this.setState({ checked: updatedChecked })
            // Reset task planning filter state
            this.props.onSetTaskPlanningFilterState(null);

            // Send event to Analytics
            ReactGA.event({
                category: 'Customer map layer',
                action: `Forest marker clicked`,
                label: `User: ${this.props.currentAuthUser.name}`
            });
        }
    }

    handleChange = name => event => {
        if (name === "all") {
            if (!this.state.allChecked) {
                const updatedChecked = this.state.checked.map(el => {
                    el.state = false;
                    return el;
                })
                this.setState({ checked: updatedChecked })
                this.props.onSetCurrentlySelectedForestId(null);
                this.setState({ allChecked: true })
            }
        } else {
            const updatedChecked = this.state.checked.map(el => {
                if (el.id === name) {
                    if (el.state === true) {
                        el.state = false;
                        this.props.onSetCurrentlySelectedForestId(null);
                        this.setState({ allChecked: true })
                    } else {
                        el.state = true;
                        this.props.onSetCurrentlySelectedForestId(el.id);
                        this.setState({ allChecked: false })
                    }
                } else {
                    el.state = false;
                }
                return el;
            })
            this.setState({ checked: updatedChecked })

            // Onboarding action if active 
            if (this.props.onboardingActive && this.props.onboardingState === 'customerSelectIntro') {
                this.props.onSetOnboardingState('drawingIntro');
                if (!this.props.mobile) {
                    this.handleClick();
                }
            } else if (this.props.onboardingActive && this.props.onboardingState === 'forestSelectIntro') {
                // Check for affiliation
                if (this.props.currentAuthUser.affiliation && ((this.props.currentAuthUser.affiliation.HD && this.props.currentAuthUser.affiliation.HD.status === 'active') || (this.props.currentAuthUser.affiliation.sls && this.props.currentAuthUser.affiliation.sls.status === 'active') || (this.props.currentAuthUser.affiliation.skovdyrkerne && this.props.currentAuthUser.affiliation.skovdyrkerne.status === 'active'))) {
                    this.props.onSetOnboardingState('navigateMap');
                } else {
                    this.props.onSetOnboardingState('drawingIntro');
                }
                if (!this.props.mobile) {
                    this.handleClick();
                }
            }
        }
        // Reset task planning filter state
        this.props.onSetTaskPlanningFilterState(null);
    };

    onExit() {
        if (!this.state.allChecked) {
            const updatedChecked = this.state.checked.map(el => {
                el.state = false;
                return el;
            })
            this.setState({ checked: updatedChecked })
            this.props.onSetCurrentlySelectedForestId(null);
            this.setState({ allChecked: true, open: false })
        }

        // Reset task planning filter state
        this.props.onSetTaskPlanningFilterState(null);

        // Send event to Analytics
        ReactGA.event({
            category: 'Customer map layer',
            action: `cancelSelectedForest`,
            label: `User: ${this.props.currentAuthUser.name}`
        });
    }

    list(disableMenu) {
        const { classes, screenHeight, mobile } = this.props;

        return (
            <List className={classes.checklist}>
                <ListItem
                    role={undefined}
                    dense
                    button
                    disabled={disableMenu}
                    onClick={this.handleChange('all')}
                    style={{ paddingLeft: 0 }}
                >
                    <Checkbox
                        checked={this.state.allChecked}
                        tabIndex={-1}
                        disableRipple
                        disabled={disableMenu}
                        style={{ marginLeft: 0 }}
                        color="primary"
                    />
                    <ListItemText primary={'Alle skove'} />
                </ListItem>

                <Divider />

                <div style={{ overflow: 'auto', maxHeight: screenHeight - (mobile ? 280 : 290) }}>
                    {this.props.currentAuthUser.forests.length > 0 && this.state.checked.map(el => (
                        <ListItem
                            key={el.id}
                            role={undefined}
                            dense
                            button
                            onClick={this.handleChange(el.id)}
                            style={{ paddingLeft: 0 }}
                            disabled={(this.props.notDisabledForestId && el.id !== this.props.notDisabledForestId)}
                        >
                            <Checkbox
                                checked={el.state}
                                tabIndex={-1}
                                disableRipple
                                style={{ marginLeft: 0 }}
                                color="primary"
                            />
                            <ListItemText
                                primary={this.props.customerList[el.id] ? this.props.customerList[el.id].forestName : ""}
                                secondary={this.props.customerList[el.id] ? this.props.customerList[el.id].name : ""}
                            />
                        </ListItem>
                    ))}
                </div>

                <Divider />

                <SpaceMenu />

                <InfoMenu
                    content={(this.props.notDisabledForestId && this.props.currentAuthUser.forests.length > 1) ? this.props.config.limitOfForestsReachedText : 'Vælg den skov som du ønsker at arbejde i.'}
                />

                <SpaceMenu />
            </List>
        )
    }

    contentMenu(forestLabelHead, forestLabel) {
        const { classes, tablet } = this.props;

        return (
            <div
                className={classes.selectedBoxContent}
                style={{
                    paddingLeft: !this.state.allChecked ? '4px' : '18px',
                    maxWidth: tablet ? '182px' : null,
                }}
            >
                <Typography
                    variant="caption"
                    noWrap
                    component={'span'}
                    style={{ color: '#747474' }}
                >
                    {forestLabelHead}
                </Typography>

                <Typography
                    variant="body2"
                    noWrap
                    component={'span'}
                >
                    {forestLabel}
                </Typography>
            </div>
        )
    }

    searchToolbar() {
        const { classes } = this.props;

        return (
            <div className={classes.search}>
                <div className={classes.searchIcon}>
                    <SearchIcon />
                </div>

                <Tooltip title="Søg efter kunder eller skove">
                    <InputBase
                        style={{ margin: '0px 0px' }}
                        placeholder="Søg"
                        onChange={this.handleSearchStringChange}
                        value={this.state.searchString}
                        classes={{
                            root: classes.inputRoot,
                            input: classes.inputInput,
                        }}
                        inputProps={{ 'aria-label': 'search' }}
                    />
                </Tooltip>
            </div>
        )
    }


    closeButton() {
        return (
            <IconButton
                aria-label="Close"
                size="medium"
                style={{ marginLeft: 6 }}
                onClick={this.onExit.bind(this)}
            >
                <Tooltip title="Luk skov" aria-label="Luk skov">
                    <CloseIcon fontSize="small" />
                </Tooltip>
            </IconButton>
        )
    }

    render() {
        const { classes } = this.props;

        // List functionality
        const checkedEl = this.state.checked.filter(el => {
            return el.state === true;
        })

        let forestLabel = "Alle";
        let forestLabelHead = "Valgt skov";
        let disableMenu = false;

        if (checkedEl.length > 0 && this.props.currentAuthUser.forests.length > 0) {
            if (this.props.customerList[checkedEl[0].id]) {
                forestLabel = this.props.mobile ? this.props.customerList[checkedEl[0].id].forestName : this.props.customerList[checkedEl[0].id].forestName + (this.props.customerList[checkedEl[0].id].name !== "" ? ", " : "") + this.props.customerList[checkedEl[0].id].name;
            }
        } else if (this.props.currentAuthUser.forests.length < 1) {
            forestLabel = "";
            forestLabelHead = "Ingen skove";
            disableMenu = true;
        }

        const impZidx = this.props.onboardingActive ? this.props.onboardingDrawToolZidx : this.state.zIdx;

        const fab = classNames(classes.fabBottom, this.props.sidebar ? classes.moveIn : classes.moveOut);
        const fabMenu = classNames(classes.fabMenuBottom, this.props.sidebar ? classes.moveIn : classes.moveOut);
        const fabSelected = classNames(classes.fabSelectedBottom, this.props.sidebar ? classes.moveIn : classes.moveOut);

        return (
            <div>
                {!this.props.mobile && <Tooltip title="Skove" aria-label="Skove">
                    <Fab
                        aria-controls="fade-menu"
                        aria-haspopup="true"
                        onClick={this.handleClick.bind(this)}
                        className={fab}
                        style={{ zIndex: this.props.onboardingForestSelecterZidx + 1, backgroundColor: this.props.onboardingCustomerSelectBtnColor }}
                        disabled={this.props.onboardingDisableCustomerSelect}
                    >
                        {this.state.open ? <CloseIcon style={{ color: '#808080' }} /> : <NaturePeopleIcon style={{ color: '#41842b' }} />}
                    </Fab>
                </Tooltip>}

                {/* NORMAL VERSION */}
                {this.state.open && <Card
                    className={fabMenu}
                    style={{ zIndex: impZidx }}
                    onClick={this.cardClickHandler.bind(this)}
                >
                    <CardContent style={{ paddingBottom: 8 }}>
                        <HeaderMenu
                            title='Skove'
                            onPress={this.handleClick.bind(this)}
                        />

                        <SpaceMenu />

                        {this.searchToolbar()}

                        {this.list(disableMenu)}
                    </CardContent>
                </Card>}

                {!this.props.mobile && <div className={fabSelected} style={{ zIndex: this.props.onboardingForestSelecterZidx }}>
                    {!this.state.allChecked && this.closeButton()}

                    {(checkedEl.length > 0 || this.props.mapCustomerShouldOpen) && this.contentMenu(forestLabelHead, forestLabel)}
                </div>}

                {/* MOBILE VERSION */}
                {((this.props.mapCustomerShouldOpen && !this.props.onboardingActive) || (this.props.mapCustomerShouldOpen && this.props.onboardingActive && (this.props.onboardingState === 'customerSelectIntro' || this.props.onboardingState === 'forestSelectIntro'))) && <Card
                    className={classes.fabMenuMobile}
                    style={{ zIndex: 102 }}
                    onClick={this.cardClickHandler.bind(this)}
                >
                    <CardContent style={{ paddingBottom: 8 }}>
                        <HeaderMenu
                            title='Skove'
                            onPress={this.props.onPress}
                        />

                        <SpaceMenu />

                        {this.searchToolbar()}

                        {this.list(disableMenu)}
                    </CardContent>
                </Card>}

                {this.props.mobile && <div className={classes.fabSelectedBottomMobile} style={{ zIndex: this.props.onboardingForestSelecterZidx }}>
                    {!this.state.allChecked && this.closeButton()}

                    {(checkedEl.length > 0 || this.props.mapCustomerShouldOpen) && this.contentMenu(forestLabelHead, forestLabel)}
                </div>}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        config: state.appConfig.mapCustomerMenu,
        currentAuthUser: state.user.currentAuthUser,
        ownerUpToFiveForestsSub: state.account.ownerUpToFiveForestsSub,
        onboardingActive: state.onboarding.onboardingActive,
        onboardingState: state.onboarding.onboardingState,
        selectedForest: state.customer.currentlySelectedForestId,
        forestMarkerClickId: state.maps.forestMarkerClickId,
        customers: state.org.customers,
        customerList: state.customer.customerList,
        customerIdList: state.customer.customerIdList,
        onboardingForestSelecterZidx: state.onboarding.forestSelecterZidx,
        onboardingDisableCustomerSelect: state.onboarding.disableCustomerSelect,
        onboardingCustomerSelectBtnColor: state.onboarding.customerSelectBtnColor,
        menuBringToFrontId: state.maps.mapMenuBringToFrontId,
        sidebar: state.layout.sidebarOpen,
        notDisabledForestId: state.maps.notDisabledForestId,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onSetCurrentlySelectedForestId: (forestId) => dispatch(actions.setCurrentlySelectedForestId(forestId)),
        onSetNotDisabledForestId: (forestId) => dispatch(actions.setNotDisabledForestId(forestId)),
        onSetOnboardingState: (s) => dispatch(actions.setOnboardingState(s)),
        onSetForestMarkerClickId: (id) => dispatch(actions.setForestMarkerClickId(id)),
        onSetMapMenuBringToFrontId: (id) => dispatch(actions.setMapMenuBringToFrontId(id)),
        onSetFilterState: (s) => dispatch(actions.setFilterState(s)),
        onSetShowFilterInMap: (s) => dispatch(actions.setShowFilterInMap(s)),
        onSetTaskPlanningFilterState: (s) => dispatch(actions.setActivityFilterState(s)),
        onEnqueueSnackbar: (message, options) => dispatch(actions.enqueueSnackbar(message, options)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MapCustomersMenu));